<app-widget-card-wrapper [title]="chartTitle" [subTitle]="chartSubtitle" [hide]="noData">
  <div *ngIf="noData === false" class="card-stretch text-center">
    <div class="responsive-text-wrapper" #wrapperEl>
      <span class="responsive-text" [style.color]="mauriWordColour" #textEl>
        {{ mauriWord }}
      </span>
    </div>
  </div>

  <div *ngIf="noData === true" class="card-stretch text-center no-data-message">
    <h5>
      Kāore he raraunga? Kāore he raru!<br />Not seeing any data? No problem!<br /><br />
      These insights are fed by data from your Rongo App. Don’t forget to use your app if you are heading out into te
      taiao.
    </h5>
  </div>
</app-widget-card-wrapper>
